import React, {createRef, RefObject} from 'react'

import AttachmentsCollection from "../../model2/attachment/attachments"
import RichEditorLexical from "../editor/editor"
import RichEditor from "../rich-editor/rich-editor"
import Attachment from "../../model2/attachment/attachment"
import LexicalEditorLocalSettings from "../editor/settings/local-settings"
import {ContentRTF} from "../editor/@type"

type Props = {
    className?                          : string
    mentions?                           : any
    projectId?                          : ID
    attachmentsCollection?              : AttachmentsCollection // used by attachment plugin
    placeholder?                        : string
    messageText?                        : string                // is used if no messageRTF
    messageRTF?                         : ContentRTF

    attachmentInMessageDefaultWidth?    : number | string
    attachmentInEditorIsResizeable?     : boolean
    stateSaveInterval?                  : number
    localSettingsName?                  : string
    localSettings?                      : LexicalEditorLocalSettings // lexical only

    useLocalSettings?                   : boolean               // for showControls in localSettings // TODO: rename parameter
    focusOnMount?                       : boolean
    editable?                           : boolean
    showControls?                       : boolean
    showUndoRedo?                       : boolean
    showSettingsButton?                 : boolean
    hideControlsAllowed?                : boolean
    forceComponentsOfViewType?          : boolean

    addField?                           : any                   // used to add "Add field button" used in editor/formulas, see addFieldConfig object
    controlsParams?                     : {
        leftChildren?   : any,
        rightChildren?  : any
    },                                              // used to add buttons to toolbar if it is enabled (showControls)

    onCommandEnterKey?                  : callback
    onKeyDown?                          : callback
    onEscape?                           : callback
    onAddAttachment?                    : callback              // if passed -> will handle select file for attachment and show attachment icon
    onPasteImage?                       : {(file:any):void}
    onChange?                           : {(messageText:string,  messageRTF: ContentRTF):void}

    children?                           : any
}

const debug = false
// const debug = "RichTextEditorUniversal"

export default class RichTextEditorUniversal extends React.Component<Props, any> {

    refEditor: RefObject<any> = createRef<any>()

    static defaultProps = {
        editable: true
    }

    getPrintContainer() {
        return this.refEditor.current?.getPrintContainer()
    }

    clear = () => {
        debug && console.log(debug, 'clear')
        this.refEditor.current?.clear()
    }

    focus = () => {
        debug && console.log(debug, 'focus')
        this.refEditor.current?.focus()
    }

    blur = () => {
        debug && console.log(debug, 'blur')
        this.refEditor.current?.blur()
    }

    updateScroll = () => {
        debug && console.log(debug, 'updateScroll')
        if (this.refEditor.current?.updateScroll) this.refEditor.current?.updateScroll()
    }

    addAttachmentToEditor(fileData: Attachment) {
        debug && console.log(debug, 'addAttachmentToEditor', fileData)
        this.refEditor.current?.addAttachmentToEditor(fileData)
    }

    addTextToEditor = (text:string, postfix:string = '') => {
        debug && console.log(debug, 'addTextToEditor', text, postfix)
        this.refEditor.current?.addTextToEditor(text, postfix)
    }

    addLinkToEditor = (label:string, url:string, postfix = '') => {
        debug && console.log(debug, 'addLinkToEditor', label, url, postfix)
        this.refEditor.current?.addLinkToEditor(label, url, postfix)
    }

    render() {
        const noMessage         = _.isEmpty(this.props.messageRTF)
        const messageIsLexical  = !!this.props.messageRTF?.v

        debug && console.log(debug, 'render', noMessage, messageIsLexical)

        if (noMessage || messageIsLexical) {
            return (
                <RichEditorLexical ref={this.refEditor}
                                   {...this.props}/>
            )
        } else {
            return (
                <RichEditor ref         = {this.refEditor}
                            {...this.props}
                            text        = {this.props.messageText}
                            rtfState    = {this.props.messageRTF}
                            type        = {!this.props.editable ? "view" : "full"}/>
            )
        }
    }
}